import { TokenProgressBar } from '@/core/components/TokenProgressBar';

import { formatTokenCount } from '@/utils/formatTokenCount';

import {
  AnalysisUsageText,
  FooterText,
  Label,
  PercentageText,
  Row,
  Title,
  TitleDot,
  TitleGroup,
  Wrapper,
} from './TokenUsageBar.styles';
import { TokenUsageBarProps } from './TokenUsageBar.types';

export const TokenUsageBar = ({
  percentage,
  usedTokens,
  remainingTokens,
  analysisTokens,
}: TokenUsageBarProps) => {
  const total = usedTokens + remainingTokens;
  const remainingPercentage = Math.max(0, 100 - percentage);

  return (
    <Wrapper>
      <Row>
        <TitleGroup>
          <TitleDot />
          <Title>AI Analyst — Token Usage</Title>
        </TitleGroup>
        {typeof analysisTokens === 'number' && (
          <AnalysisUsageText>
            This analysis used <strong>{formatTokenCount(analysisTokens)}</strong> tokens
          </AnalysisUsageText>
        )}
      </Row>
      <Row>
        <Label>Token usage this month</Label>
        <PercentageText>
          {remainingPercentage}% remaining ({formatTokenCount(remainingTokens)} /{' '}
          {formatTokenCount(total)})
        </PercentageText>
      </Row>
      <TokenProgressBar percentage={percentage} />
      <Row>
        <FooterText>{formatTokenCount(usedTokens)} tokens used</FooterText>
        <FooterText>{formatTokenCount(remainingTokens)} tokens left</FooterText>
      </Row>
    </Wrapper>
  );
};
